import { Checkbox } from '@cian/ui-kit';
import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { InlineFilter } from 'shared/components/InlineFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectDealTypeFilter } from 'shared/selectors/advancedFilters';

export const DealTypeContainer: FC = () => {
  const { label, value, visible } = useSelector(selectDealTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleIsByHomeownerChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, newValue: boolean) => {
      onChange({ action: 'setIsByHomeowner', arguments: [newValue || null] });
    },
    [onChange],
  );

  if (!visible) {
    return null;
  }

  return (
    <AdvancedFilterRow label={label}>
      <InlineFilter>
        <Checkbox label="От собственника" checked={!!value} onChange={handleIsByHomeownerChange} />
      </InlineFilter>
    </AdvancedFilterRow>
  );
};
